export default __webpack_public_path__ + "static/media/grafana.e534a936.svg";